import React from 'react'
import { useSelector } from 'react-redux'
import { LoadingIndicator, StatusSection } from '../../../../components'
import { CrackInjectionOutput, DowelingOutput } from './components'

const Output = (props) => {
  const calculation = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)
  const { isLoading, msgLevel, msgHeader, msgBody } = calculation.status

  const ErrorMessageSection = () => {
    return (
      <StatusSection
        statusLevel={staticData.status.msgLevel}
        statusIcon={'assets/images/icons/sst-icon-info.svg'}
        statusHeader={staticData.status.msgHeader}
        statusBody={staticData.status.msgBody}
      />
    )
  }

  const CalculationMessageSection = () => {
    return (
      <StatusSection
        statusLevel={msgLevel}
        statusIcon={'assets/images/icons/sst-icon-info.svg'}
        statusHeader={msgHeader}
        statusBody={msgBody}
      />
    )
  }

  // TODO development only
  // const [ showMore, setShowMore ] = useState(false)
  // const handleShowMore = (e) => {
  //   setShowMore(!showMore)
  // }
  return (
    <div className="outputSectionWrapper">
      <h2 className="sectionFlag -output">Output</h2>
      <div className="outputSection">
        <div className="container-fluid">
          {staticData.status.isLoading || isLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              {staticData.status.isError ? (
                <ErrorMessageSection />
              ) : (
                <>
                  {msgBody ? (
                    <CalculationMessageSection />
                  ) : calculation.input.subApp === '0' ? (
                    <DowelingOutput />
                  ) : (
                    <CrackInjectionOutput />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      {/*
      <Button variant="text" onClick={handleShowMore} >
        <img data-src="" className="iconic iconic-md injectSVG" alt="" />
        <span className="button__text">{showMore ? "Hide Calculation Detail" : "Show Calculation Detail"}</span>
      </Button>

      { showMore ?
        <section>
          <pre>
            calculation details: {JSON.stringify(calculation, undefined, 2)}
          </pre>
        </section> : null
      }
*/}
    </div>
  )
}

export default Output
